(() => {
  const audio = new Audio();
  let activeButton = null;
  const player = () => document.querySelector('[data-sticky-player]');
  const setIcon = (btn, playing) => { if (btn) btn.textContent = playing ? '❚❚' : '▶'; };
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-preview]');
    if (btn) {
      const src = btn.dataset.preview;
      if (!src) return;
      if (activeButton === btn && !audio.paused) { audio.pause(); setIcon(btn,false); return; }
      setIcon(activeButton,false); activeButton = btn;
      if (audio.src !== new URL(src, location.href).href) audio.src = src;
      audio.play().then(()=>setIcon(btn,true)).catch(()=>{});
      const p=player(); if(p){p.classList.add('active');p.querySelector('[data-title]').textContent=btn.dataset.title||'Beat preview';p.querySelector('[data-sub]').textContent=btn.dataset.subtitle||'Zack Uno';}
    }
    if(e.target.closest('[data-sticky-toggle]')){ if(audio.paused) audio.play(); else audio.pause(); }
    if(e.target.closest('[data-sticky-close]')){audio.pause();player()?.classList.remove('active');setIcon(activeButton,false);}
  });
  audio.addEventListener('play',()=>{const b=document.querySelector('[data-sticky-toggle]');if(b)b.textContent='❚❚';setIcon(activeButton,true)});
  audio.addEventListener('pause',()=>{const b=document.querySelector('[data-sticky-toggle]');if(b)b.textContent='▶';setIcon(activeButton,false)});
  audio.addEventListener('timeupdate',()=>{const r=document.querySelector('[data-progress]');if(r&&audio.duration)r.value=(audio.currentTime/audio.duration)*100});
  document.addEventListener('input',e=>{if(e.target.matches('[data-progress]')&&audio.duration)audio.currentTime=(e.target.value/100)*audio.duration});
  document.addEventListener('input',e=>{if(e.target.matches('[data-beat-search]')){const q=e.target.value.toLowerCase();document.querySelectorAll('[data-beat-row]').forEach(r=>r.hidden=!r.dataset.search.includes(q));}});
})();
